import { ActionTypes } from "../constants/action-types";

let wishlistHash = null;
let wishlist = [];

if (typeof window !== "undefined") {
  // try catch not required but just in case JSON.parse fails, catch error and set to null for safety
  try {
    wishlistHash = localStorage.getItem("wishlistHash");
    let temp = sessionStorage.getItem("wishlist");
    if(temp) {
      wishlist = JSON.parse(temp)?.items;
    }
  }
  catch (error) {
    wishlistHash = null
    wishlist = []
  }
}

const initialState = {
  loading_status: false,
  open_wishlist_sidebar: false,
  play_favourite_icon_animation: false,
  wishlistHashId: wishlistHash,
  wishlist: wishlist,
  wishlist_not_init: false
};

export const wishlistReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.ADD_TO_WISHLIST:
      return {
        ...state,
        play_favourite_icon_animation: true,
        wishlist: [ ...state.wishlist, payload],
      };
    case ActionTypes.REMOVE_FROM_WISHLIST:
      return {
        ...state,
        wishlist: state.wishlist.filter(
          (item) => item.ProductVariantId !== payload
        ),
      };
    case ActionTypes.INITIALIZE_WISHLIST:
      return {
        ...state,
        wishlist: payload.wishlist,
        wishlistHashId: payload.wishlistHashId,
      };
    case ActionTypes.FAVOURITE_ICON_ANIMATION_END:
      return {
        ...state,
        play_favourite_icon_animation: false,
      };
    case ActionTypes.OPEN_WISHLIST_SIDEBAR:
      return {
        ...state,
        open_wishlist_sidebar: payload,
      };
    case ActionTypes.SET_WISHLIST_LOADING_STATE:
      return {
        ...state,
        loading_status: payload,
      };
    case ActionTypes.WISHLIST_NOT_INITIALISED:
      return {
        ...state,
        wishlist_not_init: payload,
      };  
    default:
      return state;
  }
};
